import React, { useEffect, useState } from "react";
import { toast } from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { Link, NavLink, useLocation } from 'react-router-dom'
import { useNavigate } from 'react-router-dom';
import { timeSince, TOAST_DURATION, TOAST_ERROR_COLOR, TOAST_POSITION, TOAST_SUCCESS_COLOR } from "../../common/app_constant";
import { SUB_DIRECTORY } from "../../common/constant";
import { actionClientList, resetClientListResponse } from "../../routes/app/auth/my_profile/store";
import { actionLatestNotification, resetLatestNotification } from "../../routes/app/auth/notifications/store";
import { actionLogout, resetLogout } from "../../routes/app/auth/notifications/store";

const Header = () => {


    const navigate = useNavigate();
    const dispatch = useDispatch()

    const location = useLocation();

    var route = location.pathname

    const { clientList } = useSelector((state) => ({
        ...state.MyProfileStore
    }))


    const { latestNotification } = useSelector((state) => ({
        ...state.NotificationStore
    }))


    const { logout } = useSelector((state) => ({
        ...state.NotificationStore
    }))

    const [clientListArr, setClientList] = useState([])
    const [latestNotificationList, setLatestNotification] = useState(null)
    const [user, setUserObj] = useState(null);


    useEffect(() => {
        let user = JSON.parse(localStorage.getItem('userData'))
        if (user !== null) {
            let userObj = JSON.stringify(user)
            if (userObj !== null && userObj.length > 0) {
                setUserObj(userObj)
            }
        }

    }, [user]);


    useEffect(() => {
        if (user != null) {
            dispatch(actionClientList())
            dispatch(actionLatestNotification())
        }
    }, [user])

    useEffect(() => {
        if (clientList !== null) {
            dispatch(resetClientListResponse())
            if (clientList.result === true) {
                setClientList(clientList.response)
            } else {
                switch (clientList.status_code) {
                    case 401:
                        toast.error(clientList.message, {
                            duration: TOAST_DURATION,
                            position: TOAST_POSITION,
                            style: {
                                color: TOAST_ERROR_COLOR
                            }
                        })
                        localStorage.clear()
                        navigate("/login", { replace: true });
                        break;
                    default:
                }
            }
        }
    }, [clientList])

    useEffect(() => {
        if (latestNotification !== null) {
            dispatch(resetLatestNotification())
            if (latestNotification.result === true) {
                setLatestNotification(latestNotification.response)
            } else {
                switch (latestNotification.status_code) {
                    case 401:
                        toast.error(latestNotification.message, {
                            duration: TOAST_DURATION,
                            position: TOAST_POSITION,
                            style: {
                                color: TOAST_ERROR_COLOR
                            }
                        })
                        localStorage.clear()
                        navigate("/login", { replace: true });
                        break;
                    default:
                }
            }
        }
    }, [latestNotification])

    useEffect(() => {
        if (logout !== null) {
            dispatch(resetLogout())
            if (logout.result === true) {
                localStorage.clear()
                navigate("/login", { replace: true });
                toast.success(logout.message, {
                    duration: TOAST_DURATION,
                    position: TOAST_POSITION,
                    style: {
                        color: TOAST_SUCCESS_COLOR
                    }
                })
            } else {
                switch (logout.status_code) {
                    case 402:
                        toast.error(logout.message, {
                            duration: TOAST_DURATION,
                            position: TOAST_POSITION,
                            style: {
                                color: TOAST_ERROR_COLOR
                            }
                        })
                        break;
                    default:
                }
            }
        }
    }, [logout])

    const renderFirstletter = (item) => {
        const str = item
        const str2 = str?.charAt(0)
        return str2?.toUpperCase()
    }

    const renderLatestNotification = () => {

        var latestNotification = []

        latestNotificationList != null && latestNotificationList.data != null && latestNotificationList.data.length > 0 ?
            latestNotificationList.data.map((item, index) => {

                latestNotification.push(
                    <li>
                        <a className={`dropdown-item text-decoration-none ${item.readed === 0 ? 'unread' : ''}`}>
                            <div className="py-1">
                                <p className="mb-1">
                                    <b>{item.title}</b>
                                </p>
                                <p className="mb-1 text-secondary text-wrap fs-7">
                                    {item.notification}
                                </p>
                                <p className="small text-primary mb-0">{timeSince(item.created_at)}</p>
                            </div>
                        </a>
                    </li>
                )
            })

            :
            <></>
        return latestNotification
    }

    return (
        <>
            {/* BEGIN: Header*/}
            <header>
                <div className="fixed-top">
                    {/*START top header */}
                    {/* navbar */}

                    <nav className="navbar navbar-expand-md bg-white navbar-dark py-0 cust-shadow-sm cust-mt-1-6 main-navbar border-bottom">
                        <div className="container-xxl container-fluid py-0">
                            <a className="navbar-brand pt-0" href="https://www.pincinsurance.com">
                                <img
                                    className="w-156"
                                    src={`${SUB_DIRECTORY}/assets/images/pinclogo.jpg`}
                                    title=""
                                    alt="logo"
                                />
                            </a>
                            <button
                                className="navbar-toggler text-dark collapsed"
                                type="button"
                                aria-label="collapsebtn"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapsibleNavbar"
                                aria-expanded="false"
                            >
                                {/* <span class="navbar-toggler-icon text-secondary"></span> */}
                                <i className="fa fa-bars" />
                            </button>
                            {
                                user != null ?
                                    <div className="collapse navbar-collapse" id="collapsibleNavbar">
                                        <ul className="navbar-nav ms-auto">
                                            <li className="nav-item">
                                                <div className="dropdown-divider d-block d-lg-none d-md-none" />
                                                <NavLink
                                                    to='/dashboard'
                                                    className={({ isActive }) => isActive ? 'nav-link text-secondary activeroute' : 'nav-link text-secondary '}>
                                                    Dashboard
                                                </NavLink>
                                                <div className="dropdown-divider d-block d-lg-none d-md-none" />
                                            </li>

                                            <li className="nav-item">
                                                <NavLink
                                                    to='/policies'
                                                    className={({ isActive }) => isActive ? 'nav-link text-secondary activeroute' : 'nav-link text-secondary '}>
                                                    Policies
                                                </NavLink>
                                                <div className="dropdown-divider d-block d-lg-none d-md-none" />
                                            </li>
                                            <li className="nav-item">
                                                <NavLink
                                                    to='/appointments'
                                                    className={({ isActive }) => isActive ? 'nav-link text-secondary activeroute' : 'nav-link text-secondary '}>
                                                    Appointments
                                                </NavLink>
                                                <div className="dropdown-divider d-block d-lg-none d-md-none" />
                                            </li>
                                            <li className="nav-item">
                                                <NavLink
                                                    to='/claim'
                                                    className={({ isActive }) => isActive ? 'nav-link text-secondary activeroute' : 'nav-link text-secondary '}>
                                                    Claim
                                                </NavLink>
                                                <div className="dropdown-divider d-block d-lg-none d-md-none" />
                                            </li>
                                            <li className="nav-item">
                                                <NavLink
                                                    to='/enquiry'
                                                    className={({ isActive }) => isActive ? 'nav-link text-secondary activeroute' : 'nav-link text-secondary '}>
                                                    Enquiries
                                                </NavLink>
                                                <div className="dropdown-divider d-block d-lg-none d-md-none" />
                                            </li>
                                            <li className="nav-item pr-0">
                                                <NavLink
                                                    to='/policy-wallet'
                                                    className={({ isActive }) => isActive ? 'nav-link text-secondary activeroute' : 'nav-link text-secondary '}>
                                                    Policy Wallet
                                                </NavLink>
                                                <div className="dropdown-divider d-block d-lg-none d-md-none" />
                                            </li>
                                            <li class="nav-item pr-0">
                                                <a class="nav-link " href="tel: 022-66186400">
                                                    <span class="btn-secondary rounded-pill px-2 py-1 shadow-sm"><i class="fa fa-phone"></i> +91 22 6618 6400 </span></a>
                                                <div class="dropdown-divider d-block d-lg-none d-md-none"></div>
                                            </li>
                                            <li className="nav-item pr-0 d-block d-md-none">
                                                <a className={`nav-link text-secondary ${route === "/my-profile" ? 'activeroute' : ''}`}>
                                                    My Profile
                                                </a>
                                                <div className="dropdown-divider d-block d-lg-none d-md-none" />
                                            </li>
                                            <li className="nav-item pr-0 dropdown d-none d-md-block">
                                                <NavLink
                                                    to='/notifications'
                                                    className={({ isActive }) => isActive ? 'nav-link text-secondary show activeroute' : 'nav-link text-secondary'}
                                                    role="button" id="dropdownMenuLink"
                                                    data-bs-toggle="dropdown"
                                                    aria-expanded="false">
                                                    <span class="position-relative"><i
                                                        class="fa fa-bell"></i>
                                                        <span
                                                            className="position-absolute top-0 start-100 translate-middle p-1 bg-danger border border-light rounded-circle notification-count">
                                                            <small class="text-white">{latestNotificationList?.count}</small>
                                                        </span>
                                                    </span>
                                                </NavLink>
                                                <ul
                                                    className="dropdown-menu dropdown-menu-end notification-menu"
                                                    aria-labelledby="dropdownMenuLink"
                                                >
                                                    <div className="overflow-y-auto py-1">
                                                        {renderLatestNotification()}
                                                    </div>
                                                    <div className="text-center mt-1 shadow bg-light">
                                                        <Link to='/notifications' className="dropdown-item text-primary fw-bold">
                                                            View All
                                                        </Link>
                                                    </div>
                                                </ul>
                                            </li>
                                            <li className="nav-item pr-0 d-block d-md-none">
                                                <a className={`nav-link text-secondary ${route === "/my-profile" ? 'activeroute' : ''}`}
                                                    onClick={async () => {
                                                        // await localStorage.clear()
                                                        // navigate('/login')
                                                        // window.location.reload()
                                                        dispatch(actionLogout())
                                                    }}
                                                >
                                                    Logout
                                                </a>
                                                <div className="dropdown-divider d-block d-lg-none d-md-none" />
                                            </li>
                                            <li className="nav-item dropdown d-none d-md-block">
                                                <a
                                                    className={`${route === '/my-profile' ? 'nav-link  text-secondary show activeroute' : 'nav-link text-secondary'}`}
                                                    data-bs-toggle="dropdown"
                                                    role="button"
                                                    aria-expanded="false"

                                                >
                                                    <div className="nav-profile mx-auto">
                                                        {/* <img src={`${SUB_DIRECTORY}/assets/images/dummy.png`} alt="" /> */}
                                                        <div class="_name">{renderFirstletter(clientListArr != null && clientListArr.length > 0 ? clientListArr[0].name : '')}
                                                        </div>
                                                    </div>
                                                </a>
                                                <ul className="dropdown-menu dropdown-menu-end">
                                                    <li>
                                                        <NavLink to="/my-profile"
                                                            className={({ isActive }) => isActive ? 'dropdown-item' : 'dropdown-item show'}>
                                                            My profile
                                                        </NavLink>
                                                    </li>
                                                    <li>
                                                        <hr className="dropdown-divider" />
                                                    </li>
                                                    <li>
                                                        <a className="dropdown-item" onClick={async () => {
                                                            // await localStorage.clear()
                                                            // window.location.reload()
                                                            dispatch(actionLogout())
                                                        }}>
                                                            Logout
                                                        </a>
                                                    </li>
                                                </ul>
                                            </li>
                                        </ul>
                                    </div>
                                    : <></>
                            }
                        </div>
                    </nav>

                </div>
            </header>

            {/* END: Header*/}

        </>
    )

}

export default Header;